import Link from "next/link";
import Image from "next/image";

import DollarCircle from '/packages/icons/dollar-circle.svg';
import LayerGroup from '/packages/icons/layer-group.svg';
import Tag from '/packages/icons/tag.svg';
import styles from "./Specials.module.scss";

export default function Special({ item }) {
  const { id, title, photo, description, special_type } = item;

  // Determine properties based on special_type
  let href
  let tagText
  let icon

  switch (special_type) {
    case "product":
      href = `/shop?special=${id}`;
      tagText = "Sale";
      icon = <Tag />;
      break;
    case "bundle":
      href = `/deals/bundle/${id}`;
      tagText = "Bundle";
      icon = <LayerGroup />;
      break;
    default:
      break;
  }
  const imageUrl = photo?.urls?.original;

  // Regular expression to match 'tax included' in any case
  const taxIncludedRegex = /tax included/i;
  const hasTaxIncluded = taxIncludedRegex.test(description);

  return (
    <Link href={href} className="bundle-card">
      <div className={styles.imageContainer}>
        {imageUrl ?
          <Image
            src={imageUrl}
            fill
            style={{ objectFit: 'cover' }}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            alt={title}
          />
          :
          <div className={styles.fallbackTag}>
            {icon}
            <span>{tagText}</span>
          </div>
        }
      </div>
      <div className={styles.content}>
        <div className="text-ellipsis fw-600 pb-1">
          {title}
        </div>
        <div className={styles.tags}>

          <span className={styles.tag}>
            {icon} {tagText}
          </span>

          {hasTaxIncluded && (
            <span className={styles.taxIncluded}>
              <DollarCircle />
              Tax Included
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}
